(app => {

    app.config($stateProvider => {
        $stateProvider.state("Home.Contacts",
            {
                url: "/Contacts",
                component: "contacts",
                data: { 
                    pageTitle: "Contacts"
                }
            });
    });

    app.component("contacts",
        {
            templateUrl: "/App/Contacts/contacts.html",
            controller: contactsController,
            bindings: {
                currentUser: "<"
            }
        });

    function contactsController(clientApi, contactsDataTable, $stateParams) {
        const $ctrl = this;

        const getContacts = (nextPageToken) => {
            return clientApi.getCurrentUserClients(nextPageToken).then(contacts => {
                if (!contacts.NextPage) return contacts;

                return getContacts(contacts.NextPage).then(response => {
                    return contacts.concat(response);
                });
            });
        };

        $ctrl.$onInit = () => {
            $ctrl.contacts = [];

            $ctrl.loading = true;

            getContacts().then(response => {
                $ctrl.contacts = response;

                $ctrl.dataTableOptions = contactsDataTable.buildDataTableOptions($ctrl.contacts, $ctrl.currentUser);

                $ctrl.loading = false;
            });
        };
    }

})(window.app);